import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Avatar, Divider, Grid, useTheme, Box, Typography } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import BackToTopButton from "e.sic-platform.webclient/src/components/inspection/BackToTopButton";
import { AppStorage } from "e.sic-platform.webclient/src/services/app/AppStorage";

export interface ISmartAppStep {
  appStorage: AppStorage;
  step: number;
  titleKey: string;
  descriptionKey: string;
  children?: any;
  visible?: boolean;
}

export default observer(function SmartAppStep(props: ISmartAppStep) {
  const {palette} = useTheme();
  const { titleKey, descriptionKey, visible, children, appStorage } = props;
  const { step, collapsed } = appStorage;

  const done = useMemo(() => step >= props.step, [props.step, step]);

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} sm={collapsed ? 1 : 3} sx={{ display: "flex", flexDirection: "column", alignItems: "start", mt: 2, transition: "all 0.3s ease", mb: { lg: 8, xl: 4} }}>
        <Box display="flex" alignItems="center">
          <Avatar sx={{ backgroundColor: done ? palette.primary.main : "" }}>{props.step}</Avatar>
          {!collapsed && (
            <Typography
              variant="h6"
              color={done ? palette.primary.main : "GrayText"}
              sx={{ ml: 2, fontWeight: "bold" }}
            >
              {translationService.translate(titleKey)}
            </Typography>
          )}
        </Box>

        {!collapsed && (
          <Divider sx={{m: 2, borderLeftWidth: 1, display: {xs: "none", lg: "block"}}} orientation="vertical"/>
        )}

        {visible && (      
            <BackToTopButton />
        )}
      </Grid>


      {visible && (
        <Grid container rowSpacing={1} xs={12} lg={collapsed ? 11 : 9} sx={{mt: 2, ml: {xs: 2, lg: 0}, transition: "all 0.3s ease"}}>
          {children}
        </Grid>
      )}
    </Grid>
  );
});
